import type { ResourceAccessSummary } from '@einhaus/project314-types';

type ResourceAccessNoticeProps = {
    access: Pick<ResourceAccessSummary, 'canEdit' | 'ownedByUser'>;
    noun: string;
};

const ResourceAccessNotice = ({ access, noun }: ResourceAccessNoticeProps) => {
    if (access.ownedByUser) {
        return null;
    }

    if (access.canEdit) {
        return (
            <div className="mb-4 flex items-center gap-2.5 rounded-md border border-amber-700/40 bg-amber-950/20 px-4 py-3 text-sm text-amber-200/90">
                <svg className="h-4 w-4 shrink-0 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                    />
                </svg>
                <span>You have edit access to this {noun}. The owner controls sharing, publishing, and deletion.</span>
            </div>
        );
    }

    return (
        <div className="mb-4 flex items-center gap-2.5 rounded-md border border-sky-700/40 bg-sky-950/20 px-4 py-3 text-sm text-sky-200/90">
            <svg className="h-4 w-4 shrink-0 text-sky-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
                <path
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                />
            </svg>
            <span>You have read-only access to this {noun}.</span>
        </div>
    );
};

export default ResourceAccessNotice;
